<template>
  <div class="header flex-inline">
    <img class="logo" src="../../../static/logo.png" alt="logo">
    <div class="flex-inline">
      <div class="nav hidden-md-and-down">
        <el-menu :default-active="activeIndex" mode="horizontal">
          <el-menu-item index="1" @click="goPage('/')">{{ $t('navHome') }}</el-menu-item>
          <el-menu-item index="2"><el-link :underline="false" href="https://community.sharder.org" target="_blank">{{ $t('navCommunity') }}</el-link></el-menu-item>
          <el-menu-item index="3" @click="goPage('/product')">{{ $t('navProduct') }}</el-menu-item>
          <el-menu-item index="4"><el-link :underline="false" href="http://network.sharder.org:7215" target="_blank">{{ $t('navNetwork') }}</el-link></el-menu-item>
          <el-menu-item index="5" @click="whitePaperDialog=true">{{ $t('navWhitePaper') }}</el-menu-item>
          <el-menu-item index="6" @click="goPage('/roadMap')">{{ $t('navRoadmap') }}</el-menu-item>
        </el-menu>
      </div>
      <el-button class="btn-sign hidden-xs-only" round @click="loginFormDialog=true" v-show="!loginUser">{{ $t('navsignin') }}</el-button>
      <div class="user-opa" v-show="loginUser">
        <el-link class="link-user ellipsis hidden-xs-only" :underline="false" :href="BASE_HOST + '/official/center.ss'" target="_blank">{{ loginUser }}</el-link>
        <el-button class="btn-signout hidden-xs-only" round @click="logout">{{ $t('signout') }}</el-button>
      </div>
      <el-dropdown class="hidden-xs-only">
        <div class="lang">
          <span>{{ currentLang }}</span>
          <i class="ri-menu-line"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="changeLang('zh-CN')">中文</el-dropdown-item>
          <el-dropdown-item @click.native="changeLang('en-US')">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown class="mobile-nav hidden-sm-and-up" trigger="click">
        <i class="ri-menu-line"></i>
        <el-dropdown-menu class="mobile-menu">
          <el-dropdown-item :class="{'active': activeIndex==='1'}" @click.native="goPage('/')">{{ $t('navHome') }}</el-dropdown-item>
          <el-dropdown-item><el-link :underline="false" href="https://community.sharder.org" target="_blank">{{ $t('navCommunity') }}</el-link></el-dropdown-item>
          <el-dropdown-item :class="{'active': activeIndex==='2'}" @click.native="goPage('/product')">{{ $t('navProduct') }}</el-dropdown-item>
          <el-dropdown-item><el-link :underline="false" href="http://network.sharder.org" target="_blank">{{ $t('navNetwork') }}</el-link></el-dropdown-item>
          <el-dropdown-item @click.native="whitePaperDialog=true">{{ $t('navWhitePaper') }}</el-dropdown-item>
          <el-dropdown-item :class="{'active': activeIndex==='5'}" @click.native="goPage('/roadMap')">{{ $t('navRoadmap') }}</el-dropdown-item>

          <el-dropdown-item class="text-center" @click.native="loginFormDialog=true" v-show="!loginUser">
            <el-button class="btn-mobile-sign" round>{{ $t('navsignin') }}</el-button>
          </el-dropdown-item>
          <el-dropdown-item v-show="loginUser"><el-link class="link-user ellipsis" :underline="false" :href="BASE_HOST + '/official/center.ss'" target="_blank">{{ loginUser }}</el-link></el-dropdown-item>
          <el-dropdown-item class="text-center" @click.native="logout" v-show="loginUser">
            <el-button class="btn-mobile-sign" round>{{ $t('signout') }}</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 登陆 -->
    <el-dialog custom-class="dialog-form" :visible.sync="loginFormDialog">
      <div class="form-logo"></div>
      <div class="title text-left">{{ $t('loginFormTitle') }}</div>
      <el-form ref="loginForm" :model="accountForm" :rules="rules">
        <el-form-item :label="$t('accountLabel')" prop="username">
          <el-input v-model="accountForm.username"></el-input>
        </el-form-item>
        <el-form-item :label="$t('password')" prop="password">
          <el-input type="password" v-model="accountForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <div class="box-opa flex-inline">
          <span @click="dialogChange('forget', true)">{{ $t('forgotPassword') }}</span>
          <span @click="dialogChange('register', true)">{{ $t('registerNow') }}</span>
        </div>
        <el-form-item>
          <el-button class="btn-login" @click="login">{{ $t('signin') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 注册 -->
    <el-dialog custom-class="dialog-form" :visible.sync="registerDialog">
      <div class="form-logo"></div>
      <div class="title text-left">{{ $t('registerFormTitle') }}</div>
      <el-form ref="registForm" :model="accountForm" :rules="rules">
        <el-form-item :label="$t('emailLabel')" prop="username">
          <el-input v-model="accountForm.username" id="u_name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('capcha')" prop="vcode">
          <el-input v-model="accountForm.vcode">
            <el-button class="send-vcode" slot="append" @click="sendVcode" v-show="leftTime===60">{{ vcodeTip }}</el-button>
            <el-button class="send-vcode disable" slot="append" v-show="leftTime<60">{{ vcodeTip }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('setPassword')" prop="password">
          <el-input type="password" v-model="accountForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('confirmPassword')" prop="confirmPwd">
          <el-input type="password" v-model="accountForm.confirmPwd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('imgCapcha')" prop="imgVcode">
          <el-input v-model="accountForm.imgVcode">
            <el-image class="img-vcode" :src="imgVcode" slot="append" @click="changeVcodeImg"></el-image>
          </el-input>
        </el-form-item>
        <div class="box-opa flex-inline">
          <span @click="dialogChange('register')">{{ $t('signin') }}</span>
        </div>
        <el-form-item>
          <el-button class="btn-login" @click="register">{{ $t('register') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 找回密码 -->
    <el-dialog custom-class="dialog-form" :visible.sync="forgetDialog">
      <div class="form-logo"></div>
      <div class="title text-left">{{ $t('forgotFormTitle') }}</div>
      <el-form ref="forgetForm" :model="accountForm" :rules="rules">
        <el-form-item :label="$t('accountLabel')" prop="username">
          <el-input v-model="accountForm.username"></el-input>
        </el-form-item>
        <el-form-item :label="$t('capcha')" prop="vcode">
          <el-input v-model="accountForm.vcode">
            <el-button class="send-vcode" slot="append" @click="sendVcode" v-show="leftTime===60">{{ vcodeTip }}</el-button>
            <el-button class="send-vcode disable" slot="append" v-show="leftTime<60">{{ vcodeTip }}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('newPassword')" prop="password">
          <el-input type="password" v-model="accountForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('confirmPassword')" prop="confirmPwd">
          <el-input type="password" v-model="accountForm.confirmPwd" autocomplete="off"></el-input>
        </el-form-item>
        <div class="box-opa flex-inline">
          <span @click="dialogChange('forget')">{{ $t('signin') }}</span>
        </div>
        <el-form-item>
          <el-button class="btn-login" @click="forgetPwd">{{ $t('findback') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <WhitePaper @closedWhitePaperDialog="whitePaperDialog=false" :show-dialog="whitePaperDialog"></WhitePaper>
  </div>
</template>

<script>
  import { isEmail, isPhone } from '../../utils/validator'
  import { getUser, setUser, removeUser } from '../../utils/cookieUtil'
  import WhitePaper from './WhitePaperDialog.vue'

  export default {
    name: 'my-header',
    components: { WhitePaper },
    props: {
      activeIndex: {
        type: String,
        default: '1'
      }
    },
    data () {
      return {
        loginUser: '',

        whitePaperDialog: false,

        currentLang: 'English',
        language: { 'zh-CN': '中文', 'en-US': 'English' },
        loginFormDialog: false,
        registerDialog: false,
        forgetDialog: false,
        leftTime: 60,
        vcodeTip: this.$t('sendAuthCode'),
        accountForm: {
          username: '',
          password: '',
          vcode: '',
          imgVcode: '',
          confirmPwd: ''
        },
        rules: {
          username: [{ required: true, trigger: 'blur' }],
          password: [{ required: true, trigger: 'blur' }],
          confirmPwd: [{ required: true, trigger: 'blur' }],
          vcode: [{ required: true, trigger: 'blur' }],
          imgVcode: [{ required: true, trigger: 'blur' }]
        },
        imgVcode: ''
      }
    },
    mounted () {
      const user = getUser()
      if (user) {
        this.loginUser = user
      }

      this.changeVcodeImg()

      this.currentLang = this.language[this.$i18n.locale]
    },
    methods: {
      goPage (path) {
        const current = this.$router.currentRoute
        if (current.path === path) {
            return
        }
        this.$router.push({ path: path })
      },

      changeLang (lang) {
        const locale = this.$i18n.locale
        if (locale !== lang) {
          this.currentLang = this.language[lang]
          this.$i18n.locale = lang
        }
      },

      dialogChange (type, reverse) {
        if (type === 'forget') {
          this.forgetDialog = !!(reverse)
        } else if (type === 'register') {
          this.registerDialog = !!(reverse)
        }
        this.loginFormDialog = !reverse
      },

      // register
      register () {
        const account = this.accountForm.username
        const data = {
            username: account,
            email: account,
            captcha: this.accountForm.vcode,
            loginPassword: this.accountForm.password,
            imgCaptcha: this.accountForm.imgVcode
          }

        if (!isEmail(account)) {
          this.$message.error(this.$t('correctEmail'))
          return
        }
        if (this.accountForm.password !== this.accountForm.confirmPwd) {
          this.$message.error(this.$t('pwdNotSame'))
          return
        }

        this.$refs.registForm.validate(valide => {
          if (valide) {
            const loading = this.loading()
            this.$http.post('/official/register_.ss', data).then(res => {
              loading.close()
              const data = res.data
              if (data.success) {
                this.$message.success(this.$t('registerSuccess'))
                this.registerDialog = false
                this.loginFormDialog = true
              } else {
                this.$message.error(data.message || this.$t('registerFailed'))
              }
            }).catch(err => {
              console.error(err)
              loading.close()
              this.$message.error(this.$t('registerFailed'))
            })
          } else {
            this.$message.error(this.$t('completeTip'))
          }
        })
      },

      // login
      login () {
        this.$refs.loginForm.validate(valide => {
          if (valide) {
            const loading = this.loading()
            this.$http.post('/official/newLogin.ss', {
              username: this.accountForm.username,
              password: this.accountForm.password
            }).then(res => {
              loading.close()
              const data = res.data
              if (data.success) {
                this.loginFormDialog = false
                this.$message.success(this.$t('loginSuccess'))
                this.loginUser = this.accountForm.username
                // save to cookie
                setUser(this.loginUser)
                this.resetForm()
              } else {
                this.$message.error(res.code || this.$t('loginFailed'))
              }
            }).catch(err => {
              console.error(err)
              loading.close()
              this.$message.error(this.$t('loginFailed'))
            })
          } else {
            this.$message.error(this.$t('completeTip'))
          }
        })
      },

      // 忘记密码
      forgetPwd () {
        const data = {
          identification: this.accountForm.username,
          password: this.accountForm.password,
          captcha: this.accountForm.vcode
        }

        if (this.accountForm.password !== this.accountForm.confirmPwd) {
          this.$message.error(this.$t('pwdNotSame'))
          return
        }

        this.$refs.forgetForm.validate(valide => {
          if (valide) {
            const loading = this.loading()
            this.$http.post('/notification/verification_code.ss', data).then(res => {
              const result = res.data
              if (result.success) {
                data.token = result.token
                this.$http.post('/official/forgotPwd.ss', data).then(res => {
                  const result = res.data
                  loading.close()
                  if (result.success) {
                    this.$message.success(this.$t('modifySuccess'))
                    this.forgetDialog = false
                    this.loginFormDialog = true
                    this.resetForm()
                  } else {
                    this.$message.error(result.message || this.$t('modifyFailed'))
                  }
                }).catch(err => {
                  // console.error(err)
                  loading.close()
                  this.$message.error(this.$t('modifyFailed'))
                })
              } else {
                loading.close()
                this.$message.error(result.message || this.$t('invalidVCode'))
              }
            }).catch(err => {
              // console.error(err)
              loading.close()
              this.$message.error(this.$t('opaFailed'))
            })
          } else {
            this.$message.error(this.$t('completeTip'))
          }
        })
      },

      // 重置信息
      resetForm () {
        this.accountForm = {
            password: '',
            vcode: '',
            imgVcode: '',
            confirmPwd: ''
        }
      },

      // 退出登录
      logout () {
        removeUser()
        this.loginUser = ''
        location.href = this.BASE_HOST + '/logout.jspx'
      },

      // 图片验证码
      changeVcodeImg () {
        this.imgVcode = this.BASE_HOST + '/captcha.svl?r=' + new Date().getTime()
      },

      // 发送验证码
      sendVcode () {
        let url = ''
        const data = {}
        const account = this.accountForm.username
        if (!account) {
          this.$message.error(this.$t('inputAccount'))
          return
        }
        if (!isEmail(account)) {
          this.$message.error(this.$t('correctEmail'))
          return
        }
        if (isPhone(account)) {
          url = '/send/sms/captcha.ss'
          data.mobile = account
          data.bizType = 'biz_register'
        } else if (isEmail(account)) {
          url = '/send/email/captcha.ss'
          data.email = account
        } else {
          this.$message.error(this.$t('correctEmail'))
          return
        }

        this.vcodeLeftTime()
        this.$http.post(url, data).then(res => {
          console.log('发送验证码返回值', res)
        }).catch(err => {
          console.log('发送验证码失败', err)
        })
      },

      /* 验证码处理 */
      vcodeLeftTime () {
        const that = this
        that.leftTime--
        const code = setInterval(() => {
          if (that.leftTime <= 0) {
            clearInterval(code)
            that.vcodeTip = this.$t('sendAuthCode')
            that.leftTime = 60
            return
          }
          that.vcodeTip = that.leftTime + ' S ' + this.$t('retry')
          that.leftTime--
        }, 1000)
      },

      loading () {
        return this.$loading({
          lock: true,
          text: 'Loading...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/common.scss';

  /* header */
  .header {
    height: 10rem;
    line-height: 10rem;
    background-color: #000000;
  }

  .header .logo {
    width: 22.2rem;
    height: 5rem;
    margin-left: 6.1rem;
  }

  .nav .el-menu-item,
  .nav a {
    font-size: 2rem;
    font-weight: normal;
  }
  .nav a span {
    height: 60px;
    line-height: 60px;
  }

  .btn-sign {
    margin: 0 7.5rem;
    font-weight: bold;
    font-size: 2rem;
    color: #ffffff;
    background-color: #000000;
    border-color: #ffffff;
    border-radius: 30px;
  }

  .btn-mobile-sign {
    padding: 5px 10px;
    color: #ffffff;
    background-color: #000000;
    border-color: #ffffff;
    border-radius: 30px;
  }

  .user-opa {
    max-width: 260px;
    margin: 0 4rem;

    .el-link.el-link--default {
      transition: all .3s ease;
    }
    .el-link.el-link--default:hover {
      color: $color;
      transform: scale(1.1, 1.1);
    }
  }
  .link-user {
    color: $color;

  }
  .btn-signout {
    margin-left: 2rem;
    color: #ffffff;
    background-color: #000000;
    border-color: #ffffff;
  }

  .lang {
    display: flex;
    align-items: center;
    color: #ffffff;
    margin-right: 3.2rem;
    font-size: 1.6rem;
    cursor: pointer;

    &:hover {
      color: $color;
    }

    i {
      font-size: 2rem;
      margin-left: 1.4rem;
    }
  }

  .mobile-menu .active {
    color: $color;
  }
  /* header end */

  .text-center {
    text-align: center;
  }
</style>
<style lang="scss" scoped>
  // media query
  @media screen and (max-width: 1660px) {
    .nav .el-menu--horizontal > .el-menu-item:not(:first-child) {
      margin-left: 2rem;
    }
  }

  @media screen and (max-width: 1600px) {
    .nav .el-menu--horizontal > .el-menu-item:not(:first-child) {
      margin-left: 0;
    }
  }

  @media screen and (max-width: 1500px) {
    .nav .el-menu-item,
    .nav a {
      font-size: 1.6rem;
    }
  }

  @media screen and (max-width: 1400px) {
    .header {
      .logo {
        max-width: 14rem;
        height: auto;
        margin-left: 1rem;
      }
    }
    .btn-sign {
      margin: 0 3rem;
    }
  }

  @media screen and (max-width: 768px) {
    .header {
      height: 6rem;
      line-height: 6rem;
    }

    .mobile-nav {
      display: block;

      .ri-menu-line {
        font-size: 2rem;
        color: #FFFFFF;
        margin-right: 1rem;
      }
    }
  }
</style>
<style lang="scss">
  /* 组件样式修改 */
  .nav {
    .el-menu.el-menu--horizontal {
      background-color: #000000;
      border: none;
    }
    .el-menu--horizontal > .el-menu-item {
      color: #ffffff;
      border-bottom: none;

      &::after {
        content: '';
        height: 3px;
        position: absolute;
        transition: all .5s ease;
        bottom: 0;
        left: 50%;
        opacity: 0;
        transform: translateX(-50%);
        background-color: $color;
      }
    }

    .el-menu--horizontal > .el-menu-item:not(:first-child) {
      margin-left: 5rem;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
      /* active font 颜色保持  */
      color: $color;
      font-weight: bold;

      &::after {
        /*width: 40px;*/
        opacity: 1;
      }
    }

    .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
    .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
      color: $color;
      background-color: #000000;
    }

    .el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
      &::after {
        width: 40px;
        opacity: 1;
      }
    }
  }

  .dialog-form {
    width: 40%;

    .el-dialog__body {
      padding-left: 20%;
      padding-right: 20%;

      .form-logo {
        width: 22.2rem;
        height: 5rem;
        background: url('../../../static/logo-black.png') center no-repeat;
        background-size: contain;
      }

      .title {
        font-weight: bold;
        font-size: 3rem;
        color: #000000;
      }

      .el-input__inner {
        padding-left: 0;
        border-radius: 0;
        border-width: 0 0 1px 0;

        &:focus {
          border-color: $color;
        }
      }

      .box-opa {
        height: 2rem;
        line-height: 2rem;
        margin-bottom: 4rem;
        span {
          cursor: pointer;
          text-decoration: underline;

          &:hover {
            color: $color;
          }
        }
      }

      .btn-login {
        min-width: 125px;
        padding: 1.8rem 4.8rem;
        border-radius: 30px;
        color: #FFFFFF;
        font-weight: bold;
        background-color: #000000;
      }

      .send-vcode {
        padding: 0.9rem 2.4rem;
        border-radius: 30px;
        color: #FFFFFF;
        background-color: #000000;

        &.disable {
          background-color: #B3B3B3;
          cursor: not-allowed;
        }
      }

      .el-input-group__append {
        background: none;
        border: none;
      }

      .img-vcode {
        width: 100px;
        height: 40px;
        border: 1px solid #000000;
        border-radius: 4px;
      }
    }
  }

  /* 语言切换下拉菜单 */
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    color: $color;
  }

  .mobile-menu {
    padding: 0;

    .el-dropdown-menu__item {
      padding: 0 10px;
    }
  }

  @media screen and (max-width: 1200px) {
    .dialog-form {
      width: 70%;
    }
  }

  @media screen and (max-width: 768px) {

    .dialog-form {
      width: 90%;

      .el-dialog__body {
        padding-left: 5%;
        padding-right: 5%;

        .form-logo {
          max-width: 14rem;
          height: 3.15rem;
          background-size: contain;
        }

        .title {
          font-size: 2rem;
        }
      }
    }
  }

</style>
